module.exports = __webpack_public_path__ + "static/img/crmBonus.d5333ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/crmBonus.png
// module id = gFHw
// module chunks = 1